import { MeterBarPlot } from '../../shared/components/meter-bar-plot/MeterBarPlot.js';
import { useMeterBarChartData } from '../context/MeterBarChartDataContext.js';
import { MeterBarChartOverlay } from './MeterBarChartOverlay/MeterBarChartOverlay.js';
import { MeterBarChartSegment } from './MeterBarChartSegment/MeterBarChartSegment.js';
import { MeterBarChartThresholds } from './MeterBarChartThresholds/MeterBarChartThresholds.js';
import { useMeterBarLayoutSize } from '../../shared/context/MeterBarLayoutSize.context.js';

export const MeterBarChartPlotArea = () => {
  const { thresholdIndicators } = useMeterBarChartData();
  const { segmentHeight } = useMeterBarLayoutSize();

  return (
    <MeterBarChartOverlay>
      <MeterBarPlot>
        <MeterBarChartSegment />
      </MeterBarPlot>
      {thresholdIndicators && (
        <MeterBarChartThresholds
          thresholdIndicators={thresholdIndicators}
          segmentHeight={segmentHeight}
        />
      )}
    </MeterBarChartOverlay>
  );
};

(
  MeterBarChartPlotArea as typeof MeterBarChartPlotArea & {
    displayName: string;
  }
).displayName = 'MeterBarChartPlotArea';
